import { getStoreApiUrl } from '@/utils/common';
import { getErrorMessage } from '@/utils/api';

/**
 * 장바구니 카운트
 * @returns 
 * {
 *   error: boolean, 에러여부
 *   count: number, 카운트
 * }
 */
export const getCartCount = async () => {
  const rootStore = useRootStore();
  const authStore = useAuthStore();
  
  let error = false;
  let count = 0;
  
  if (authStore.isLogin) {
    const { data: result, error: err } = await useNuxtApp().$sendGet({
      url: getStoreApiUrl('cart'),
      showDefaultLoading: false,
    });
    
    if (err) {
      error = true;
    } else if (result?.RESULT_CODE === '0') {
      count = result.DATA ?? 0;
    } else if (result && result.RESULT_CODE !== '500') {
      rootStore.toast(getErrorMessage(result.RESULT_CODE ?? ''));
    }
  }
  
  
  return {
    error,
    count,
  }
};

// 장바구니 갯수 업데이트
export const updateCartCount = async (): Promise<void> => {
  const store = useMainStore();
  const { count } = await getCartCount();
  store.saveCartCount(count);  
};

export const goCart = async (): Promise<void> => {
  const authStore = useAuthStore();
  
  if (authStore.isLogin) {
    navigateTo('/order/cart');
  } else {
    removeLoginSessionId();
    showLoginPage('/order/cart');
  }
};

// 해외전용 여부
export const getCh = async () => {
  const { data } = await useNuxtApp().$sendGet({
    url: `${getStoreApiUrl('etc_v2')}/l3/common/isCh`,
    showDefaultLoading: false,
    apiReload: false,
  });
  
  return data?.RESULT_CODE === '0' ? data.DATA : false;
};